<template>
    <div class="saleoutView">
        <vxe-layout-container vertical>
            <vxe-layout-header>
                <vxe-form :data="formData">
                    <vxe-form-item field="fromdate" title="日期从" span="4">
                        <vxe-date-picker v-model="formData.fromdate" placeholder="请选择开始日期" />
                    </vxe-form-item>
                    <vxe-form-item field="enddate" title="日期到" span="4">
                        <vxe-date-picker v-model="formData.enddate" placeholder="请选择结束日期" />
                   </vxe-form-item>
                    <vxe-form-item field="customer" title="客户名称" span="4">
                        <template #default>
                            <vxe-input v-model="formData.customer" type="search" placeholder="请输入客户名称" clearable
                                @search-click="handleShowSearchCustomer" @keyup.enter="handleShowSearchCustomer"
                                class="form-input" />
                        </template>
                    </vxe-form-item>
                    <vxe-form-item span="8">
                        <vxe-button type="submit" status="primary" @click="handleSearch">查询</vxe-button>
                        <vxe-button icon="vxe-icon-print" status="primary" :options="downBtns" @dropdown-click="dropdownClickEvent">下拉按钮</vxe-button>
                    </vxe-form-item>
                </vxe-form>
            </vxe-layout-header>
            <vxe-layout-body>
                <vxe-table border show-overflow height="100%" :data="tableData" show-footer ref="tableref" :loading="loading"
          :cell-config="{ height: 30 }" :footer-data="footerData">
                    <vxe-column type="seq" width="40" title="序号"></vxe-column>
                    <vxe-column field="ckdh" title="出库单号" min-width="160" />
                    <vxe-column field="rq" title="日期" width="120">
                        <template #default="{ row }">
                            {{ row.rq ? row.rq.slice(0, 10) : '' }}
                        </template>
                    </vxe-column>

                    <vxe-column field="spbh" title="商品编号" width="120" />
                    <vxe-column field="sP_QM" title="商品全名" min-width="200" />
                    <vxe-column field="sP_DW" title="单位" width="80" align="center" />

                    <vxe-column field="sl" title="数量" width="90" align="right" />
                    <vxe-column field="dj" title="单价" width="110" align="right">
                        <template #default="{ row }">
                            {{ formatMoney(row.dj) }}
                        </template>
                    </vxe-column>
                    <vxe-column field="hj" title="合计" width="120" align="right">
                        <template #default="{ row }">
                            {{ formatMoney(row.hj) }}
                        </template>
                    </vxe-column>

                    <vxe-column field="isDuizhang" title="是否对账" width="100" align="center">
                        <template #default="{ row }">
                            <span :style="{ color: row.isDuizhang ? '#67c23a' : '#e6a23c' }">
                                {{ row.isDuizhang ? '已对账' : '未对账' }}
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column field="bz" title="备注" min-width="160" show-overflow="tooltip" />

                </vxe-table>
            </vxe-layout-body>
        </vxe-layout-container>
        <!-- 选择客户* -->
        <vxe-modal v-model="showSelectCustomer" width="60vw" height="60vh" destroy-on-close title="客户选择">
            <template #default>
                <selectCustomer @select="handleSelectCustomer" @cancel="showSelectCustomer = false"
                    :MnemonicPhraseProp="formData.customer">
                </selectCustomer>
            </template>
        </vxe-modal>
    </div>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue'
import { VxeUI } from 'vxe-pc-ui'
import dayjs from 'dayjs'
import request from '@/request/request.js'
import formatMoney  from '../utils/formatMoney'
import { sumNum } from '../utils/calculate'
import selectCustomer from '../components/selectComp/selectCustomerComp.vue'
import PrintHelper from '../utils/PrintHelper'
const loading = ref(false)
const tableData = ref([])
const showSelectCustomer = ref(false)
const tableref = ref()
const downBtns = ref([
  { name: '1', content: '打印预览' },
  { name: '2', content: '打印编辑' },
])
const dropdownClickEvent = (params) => {
    PrintHelper({ doc: formData, details: tableData.value, report: '销售对账单', useful: params.option.content })
  
}
onMounted(async () => {
    await handleSearch()
})
const handleShowSearchCustomer = async () => {
    showSelectCustomer.value = true
}
const handleSelectCustomer = async (data) => {
    if (data) {
        formData.customer = data.khmc
        formData.customerID = data.bh
    }
    showSelectCustomer.value = false
    await handleSearch()
}


const formData = reactive({
    fromdate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    enddate: dayjs().format('YYYY-MM-DD'),
    customer: '',
    customerID: ''
})
const handleSearch = async () => {
    if (formData.customerID!='') {
        try {

            loading.value = true
            const res = await request.post('/Saledoc/SaleRecon', {
                fromDate: formData.fromdate,
                endDate: formData.enddate,
                Customer: formData.customerID
            })
            console.log(res.data)
            tableData.value = res.data
            updateFootEvent()
            // 调用API搜索
            loading.value = false
        } catch (error) {
            loading.value = false
            VxeUI.modal.message({
                id: 'myUniqueMsg',
                content: error,
                status: 'error'
            })
        }
    }
}


// 在值发生改变时更新表尾合计
const updateFootEvent = () => {
    updateFootCount(tableData.value)
}
const updateFootCount = (list) => {
    const [sumNObj] = footerData.value
    sumNObj.hj = sumNum(list, 'hj')
}
const footerData = ref([{ seq: '合计', hj: '0', total: '0' }])
</script>
<style scoped>
.saleoutView {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.table-wrapper {
    flex: 1;
    min-height: 0;
    margin-top: 10px;
}
</style>